import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

interface ChannelsSectionProps {
  activeCategory: string;
  onSelect: (id: string) => void;
}

export default function ChannelsSection({ activeCategory, onSelect }: ChannelsSectionProps) {
  return (
    <section id="channels" className="w-full border-y border-background-200 bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="分类频道"
          title="按兴趣挑一个频道慢慢逛"
          desc="不同频道的围观节奏差别很大：有的热度来得快也退得快，有的能持续讨论好几天。选一个你关心的方向，榜单会立刻为你筛选。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => {
            const isActive = activeCategory === cat.id;
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => onSelect(cat.id)}
                className={
                  isActive
                    ? "group cursor-pointer rounded-lg border border-primary-300 bg-primary-50 p-5 text-left transition-colors"
                    : "group cursor-pointer rounded-lg border border-background-200 bg-background-100 p-5 text-left transition-colors hover:border-primary-200 hover:bg-background-50"
                }
              >
                <div className="flex items-center justify-between">
                  <span
                    className={
                      isActive
                        ? "flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50"
                        : "flex h-11 w-11 items-center justify-center rounded-md bg-background-50 text-primary-600"
                    }
                  >
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <span className="rounded-full bg-background-200 px-2.5 py-1 text-xs font-label text-foreground-600">
                    {cat.count} 条
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {cat.name}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-label font-medium text-primary-600">
                  {isActive ? "当前正在浏览" : "查看该频道"}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}